import { inject, injectable } from 'inversify';

import { removeTrailingSlash } from '@desygner/ui-common-svg-utils';

import { IConfigStoreInjector, IViewerStoreInjector, TYPES } from '../../inversify.config';
import { buildBrandUrl, getExitDomainUrl, normalizePath } from '../../utils/url.util';
import { IPostMessageManager } from './postmessage-manager';

export interface IProjectManager {
  quitViewer(): void;
}

@injectable()
export class ProjectManager implements IProjectManager {
  constructor(
    @inject(TYPES.Viewer.PostMessageManager)
    private readonly postMessageManager: IPostMessageManager,
    @inject(TYPES.Store.Config)
    private readonly configStore: IConfigStoreInjector,
    @inject(TYPES.Store.Viewer)
    private readonly viewerStore: IViewerStoreInjector
  ) {}

  public quitViewer(): void {
    const targetUrl = this.resolveExitUrl();

    if (this.postMessageManager.isEmbedded()) {
      this.postMessageManager.sendToParent({
        type: 'NAVIGATE',
        payload: { url: targetUrl },
      });
    } else {
      window.location.href = targetUrl;
    }
  }

  private resolveExitUrl(): string {
    const configState = this.configStore.getState();
    const { resources, exitEditor } = configState;
    const { company, project } = this.viewerStore.getState();
    const baseDomainUrl = removeTrailingSlash(resources?.domainUrl || window.location.origin);
    const targetPath =
      (project.type === 'template' ? exitEditor?.template : exitEditor?.design) ??
      exitEditor?.homePage ??
      '/';

    if (company?.is_workspace && company.domain) {
      const normalizedPath = normalizePath(targetPath);

      return getExitDomainUrl(baseDomainUrl, company.domain, normalizedPath);
    }

    return buildBrandUrl(baseDomainUrl, targetPath);
  }
}
